import { FlyoutData } from '@/lib/interfaces';

interface GetLiveSummaryParams {
  market: string;
  language: string;
  context?: string;
}
export const getLiveSummary = ({ market, language, context }: GetLiveSummaryParams): Promise<FlyoutData> => {
  const { VUE_APP_VMOS_API_ENDPOINT } = process.env;
  const summaryEndpoint = `${VUE_APP_VMOS_API_ENDPOINT}${market}/${language}/${context ? context : 'OWF'}/live/summary`;

  return fetch(summaryEndpoint, {
    method: 'GET',
  }).then((response) => {
    if (response.status >= 200 && response.status < 400) {
      return response.json();
    } else {
      throw new Error(`Unable to fetch due to ${response.status} error!`);
    }
  });
};
